import { createSlice } from '@reduxjs/toolkit';

import { IFileUploadState } from './slice.interface';

const initialState: IFileUploadState = {
  errors: [],
  filesProcessingInProgress: false,
};
export const fileUploadStateSlice = createSlice({
  name: 'file-upload-state',
  initialState,
  reducers: {
    setFilesUploadInProgress: (state, action) => {
      state.filesProcessingInProgress = action.payload;
    },
    setFileUploadErrors: (state, action) => {
      state.errors = action.payload;
    },
    clearFileUploadErrors: state => {
      state.errors = [];
    },
  },
  extraReducers: builder => {},
});

export const { setFilesUploadInProgress, setFileUploadErrors, clearFileUploadErrors } =
  fileUploadStateSlice.actions;
export default fileUploadStateSlice.reducer;
